import { observer } from 'mobx-react';
import { FC, useCallback, useMemo } from 'react';
import ConfigPicker from '../../../../components/ConfigPicker/ConfigPicker';
import LayoutImage from '../../../../components/LayoutImage/LayoutImage';
import configMobileStore from '../../stores';
import { IConfigMobile, IConfigMobileLayout } from '../../types';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

const MobileConfigLayoutTab: FC = observer((): JSX.Element => {
  const { menuLayout, menuListLayout } = configMobileStore.layout;

  const pickerOptions = useMemo((): IPickerOption[] => {
    return [
      { value: 'menu', label: localeStore.t('menu') },
      { value: 'cart', label: localeStore.t('txt_checkout') },
    ];
  }, []);

  const menuLayoutImages = useMemo((): IPickerOption[] => {
    return [
      { value: 'consumer_layout_vertical', label: localeStore.t('layout_vertical') },
      { value: 'consumer_layout_horizontal', label: localeStore.t('layout_horizontal') },
      { value: 'consumer_layout_vertical_quantity', label: localeStore.t('layout_vertical_quantity') },
      { value: 'consumer_layout_horizontal_quantity', label: localeStore.t('layout_horizontal_quantity') },
    ];
  }, []);

  const menuListLayoutImages = useMemo((): IPickerOption[] => {
    return [
      { value: 'consumer_layout_slider', label: localeStore.t('layout_slider') },
      { value: 'consumer_layout_infinite_scroll', label: localeStore.t('layout_infinite_scroll') },
    ];
  }, []);

  const changeTimePicker = useCallback((value: string | number) => {
    configMobileStore.changeConfigTimePicker(value as IConfigMobile['layout']['timePickerPosition']);
  }, []);

  const changeLayout = (field: keyof IConfigMobileLayout) => (value: string | undefined) => {
    configMobileStore.changeLayout({ [field]: value });
  };

  return (
    <div className="d-flex flex-column mt-4">
      <ConfigPicker
        title="time_picker_position"
        activeTab={configMobileStore.layout.timePickerPosition}
        options={pickerOptions}
        onChangeTab={changeTimePicker}
        className="mobile-layout-picker"
        titleClassName="mobile-layout-picker__title"
      />

      <Text type={TEXT.SECTION_HEADER} text="items_card" className="mt-6" />
      <div className="d-flex flex-row mt-4 gap-20">
        {menuLayoutImages.map((image) => (
          <LayoutImage key={image.value} image={image} selectedImage={menuLayout} onSelect={changeLayout('menuLayout')} />
        ))}
      </div>

      <Text type={TEXT.SECTION_HEADER} text="menu_layout" className="mt-6" />
      <div className="d-flex flex-row mt-4 gap-20">
        {menuListLayoutImages.map((image) => (
          <LayoutImage key={image.value} image={image} selectedImage={menuListLayout} onSelect={changeLayout('menuListLayout')} />
        ))}
      </div>
    </div>
  );
});

export default MobileConfigLayoutTab;
